export interface Project {
  id: number
  title: string
  category: 'web' | 'mobile' | 'branding'
  image: string
  description: string
  fullDescription?: string
  technologies?: string[]
  year?: string
  client?: string
  role?: string
}

export const projectsData: Project[] = [
  {
    id: 1,
    title: 'Dredget Job Listing Application',
    category: 'mobile',
    image:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/uKxFGwAJZP6XrGP9wFrwHX/0shots_solll.png',
    description:
      'Responsive marketing website for the Dredget mobile application, showcasing features and driving app downloads through strategic call-to-actions.',
    fullDescription:
      'Dredget is a comprehensive job listing mobile application designed to connect job seekers with employers in real-time. The application features an intuitive interface, advanced search capabilities, and seamless user experience across all devices.',
    technologies: ['React Native', 'TypeScript', 'Firebase', 'Google Maps API'],
    year: '2023',
    role: 'Lead UX/UI Designer',
  },
  {
    id: 2,
    title: 'My Bank Mobile Banking App',
    category: 'mobile',
    image:
      'https://cdn.magicpatterns.com/uploads/6wFRyGhHHMY83XK9sHka6Y/kikk.png',
    description:
      'Modern mobile banking application with card management, instant transfers, multi-currency accounts, and real-time balance tracking for seamless financial management.',
    fullDescription:
      'My Bank is a comprehensive mobile banking application designed to give users complete control over their finances. The app features intuitive card management with freeze/unfreeze capabilities, seamless money transfers with real-time exchange rates, multi-currency account support, and detailed spending analytics. With a clean, modern interface and robust security features, My Bank makes everyday banking simple and accessible. The design emphasizes clarity and ease of use, with step-by-step transfer flows, clear transaction details, and instant notifications.',
    technologies: [
      'React Native',
      'TypeScript',
      'Banking API',
      'Secure Authentication',
      'Push Notifications',
    ],
    year: '2024',
    role: 'Lead Mobile UX/UI Designer',
  },
  {
    id: 3,
    title: 'AuraTrade Wellness & Trading App',
    category: 'mobile',
    image:
      'https://cdn.magicpatterns.com/uploads/5JCPuw1jeiDAAfKqdfouEp/536shots_so.png',
    description:
      'Innovative mobile platform combining wellness product marketplace with precious metals trading, offering real-time gold and silver prices alongside curated self-care collections.',
    fullDescription:
      'AuraTrade is a groundbreaking mobile application that bridges the gap between personal wellness and financial wellness. The app features a unique dual marketplace where users can shop for premium self-care products including skincare, oils, and supplements, while simultaneously tracking and trading precious metals like gold and silver. With real-time market prices, percentage change indicators, and organized product collections, AuraTrade makes it easy to invest in both your health and your wealth. The clean, intuitive interface features a calming mint color palette, smooth navigation, and thoughtfully organized categories for seamless browsing and purchasing.',
    technologies: [
      'React Native',
      'TypeScript',
      'Real-time Market Data API',
      'E-commerce Integration',
      'Payment Processing',
    ],
    year: '2024',
    role: 'Lead Mobile UX/UI Designer',
  },
  {
    id: 4,
    title: 'Marketplace Mobile App',
    category: 'mobile',
    image:
      'https://cdn.magicpatterns.com/uploads/jsc8ne5yJcbKE4FEQeJxXJ/665shots_so.png',
    description:
      'Peer-to-peer marketplace mobile app for buying and selling items locally, featuring advanced search filters, favorites, photo uploads, and secure messaging between buyers and sellers.',
    fullDescription:
      'Marketplace is a comprehensive peer-to-peer mobile marketplace application that makes buying and selling items locally simple and secure. The app features an intuitive browsing experience with featured items, advanced filtering by category and price, and a powerful search function. Sellers can easily list items with multi-photo uploads, detailed descriptions, and condition notes, while buyers can save favorites, filter results, and communicate directly with sellers through in-app messaging. The clean, modern interface uses a fresh teal accent color and card-based layouts for easy scanning of listings. With location-based search, secure transactions, and user profiles, Marketplace creates a trusted community for local commerce.',
    technologies: [
      'React Native',
      'TypeScript',
      'Image Upload',
      'Real-time Messaging',
      'Location Services',
      'Payment Integration',
    ],
    year: '2024',
    role: 'Lead Mobile UX/UI Designer',
  },
  {
    id: 5,
    title: 'KODIF Coupon App',
    category: 'mobile',
    image:
      'https://cdn.magicpatterns.com/uploads/u7chrVUmzMMuVpD3mfQTNM/IMG_94511FE0659D-1.jpg',
    description:
      'Smart coupon aggregator app that helps users save money with discount codes for groceries, fashion, and weekend deals, featuring one-tap copy functionality and expiration tracking.',
    fullDescription:
      'KODIF is an intelligent coupon and discount code aggregator designed to help users maximize savings across multiple categories including groceries, fashion, and weekend deals. The app features a clean, minimalist interface with dark coupon cards that display store names, discount percentages, promo codes, and expiration dates at a glance. Users can easily filter deals by category, save favorite coupons for later, and copy promo codes with a single tap for instant use. The app includes smart notifications for expiring deals, personalized recommendations based on shopping habits, and a comprehensive search function to find specific store discounts. With its intuitive design and practical functionality, KODIF makes saving money effortless and accessible for everyday shopping.',
    technologies: [
      'React Native',
      'TypeScript',
      'Coupon API',
      'Push Notifications',
      'Clipboard Integration',
      'Category Filtering',
    ],
    year: '2024',
    role: 'Lead Mobile UX/UI Designer',
  },
  {
    id: 6,
    title: 'AquaShine Car Wash Service',
    category: 'web',
    image:
      'https://cdn.magicpatterns.com/uploads/iKwL79qXHHcM2yBvVfeC5m/Screenshot_2025-11-14_at_20.08.06.png',
    description:
      'Premium car wash service website with online booking system, featuring eco-friendly services, paint protection, and fast service delivery with a clean, modern design.',
    fullDescription:
      'AquaShine is a professional car wash service website designed to make booking premium vehicle care simple and convenient. The site features a vibrant blue color scheme that evokes cleanliness and water, with a bold hero section showcasing the "Shine Like New" promise. The platform highlights key service benefits including eco-friendly washing methods, premium quality care, paint protection services, and fast turnaround times. With an intuitive online booking system, customers can easily schedule their car wash appointments, select service packages, and manage their bookings. The clean, modern design emphasizes trust and professionalism while making the booking process seamless. The website includes detailed service descriptions, pricing transparency, customer testimonials, and contact information for a complete service experience.',
    technologies: [
      'React',
      'TypeScript',
      'Tailwind CSS',
      'Booking System',
      'Payment Integration',
      'Responsive Design',
    ],
    year: '2024',
    role: 'Lead Web Designer',
  },
  {
    id: 7,
    title: 'Dredget Job Search Platform',
    category: 'web',
    image:
      'https://cdn.magicpatterns.com/uploads/xgyLWHoE5waJH9nvEPGYCK/Screenshot_2025-11-30_at_18.50.40.png',
    description:
      'Professional job search platform connecting job seekers with opportunities at top companies, featuring advanced search filters, featured job listings, and streamlined application process.',
    fullDescription:
      'Dredget Job Search Platform is a comprehensive web-based job portal designed to simplify the job hunting process. The platform features a powerful search engine with keyword and location filters, curated featured job listings from leading companies like Google, Spotify, Facebook, and Amazon, and a clean, distraction-free interface that puts opportunities front and center. With salary transparency, one-click applications, and company profiles, Dredget makes it easy for job seekers to find and apply to their dream roles. The design emphasizes clarity and efficiency, with a professional aesthetic that builds trust while maintaining ease of use.',
    technologies: [
      'React',
      'TypeScript',
      'Job Search API',
      'Tailwind CSS',
      'Database Integration',
    ],
    year: '2024',
    role: 'Lead Web Designer',
  },
  {
    id: 8,
    title: 'EstMove Moving Service',
    category: 'web',
    image:
      'https://cdn.magicpatterns.com/uploads/v5KvQnM78sctiNjDbPyV11/iEst_Move.png',
    description:
      'Professional moving service platform with online booking system, service listings, and seamless customer experience across Estonia.',
    fullDescription:
      'EstMove is a comprehensive moving service platform designed to simplify the relocation process across Estonia. The website features an intuitive booking system, detailed service offerings including home moving, packing services, and special item handling. With a clean, modern design and streamlined user flows, EstMove makes it easy for customers to plan and book their move online.',
    technologies: ['React', 'TypeScript', 'Tailwind CSS', 'Booking System'],
    year: '2024',
    role: 'Lead Web Designer',
  },
  {
    id: 9,
    title: 'Market Hub E-commerce Platform',
    category: 'web',
    image:
      'https://cdn.magicpatterns.com/uploads/i4Uj6RD1vuYstW7JaHtNKb/12.png',
    description:
      'Multi-vendor marketplace platform connecting buyers with trusted sellers worldwide, featuring secure payments, product categories, and seamless shopping experience.',
    fullDescription:
      'Market Hub is a comprehensive e-commerce marketplace platform designed to connect buyers with unique products from trusted sellers around the world. The platform features an intuitive product browsing experience, secure payment processing, fast delivery options, and 24/7 customer support. With organized category navigation, featured product showcases, and seller tools, Market Hub creates a trusted marketplace environment for both buyers and sellers.',
    technologies: [
      'React',
      'TypeScript',
      'E-commerce API',
      'Payment Gateway',
      'Tailwind CSS',
    ],
    year: '2024',
    role: 'Lead UX/UI Designer',
  },
  {
    id: 10,
    title: 'Dredget Marketing Website',
    category: 'web',
    image:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/suzZ4AqWeYLAm4m6237K6P/2B2B2B98.png',
    description:
      'Responsive marketing website for the Dredget mobile application, showcasing features and driving app downloads through strategic call-to-actions.',
    fullDescription:
      'A modern, conversion-focused marketing website designed to showcase the Dredget app features and drive downloads. The site features engaging animations, clear value propositions, and optimized user flows.',
    technologies: ['React', 'Tailwind CSS', 'Framer Motion', 'Next.js'],
    year: '2023',
    role: 'Web Designer & Developer',
  },
  {
    id: 11,
    title: 'Dredget Marketing Campaign',
    category: 'branding',
    image:
      'https://cdn.magicpatterns.com/uploads/cccQzTKfJkksYLfomummtk/38.png',
    description:
      'Comprehensive outdoor advertising campaign featuring bold billboard designs, promotional posters, and brand materials with distinctive green and yellow branding.',
    fullDescription:
      'Dredget Marketing Campaign is a multi-channel branding initiative designed to increase brand awareness and drive app downloads through strategic outdoor advertising. The campaign features eye-catching billboard designs with bold typography, the iconic DredGET eye logo, and a vibrant green and yellow color palette that stands out in urban environments. The materials include large-format outdoor billboards, digital display mockups, and promotional posters, all maintaining consistent brand identity while communicating the core message: "Find a job with ease - job listings on your mobile." The campaign successfully combines strong visual impact with clear messaging to attract job seekers in high-traffic areas.',
    technologies: [
      'Adobe Photoshop',
      'Adobe Illustrator',
      'Print Design',
      'Outdoor Advertising',
    ],
    year: '2024',
    role: 'Brand Designer & Art Director',
  },
  {
    id: 12,
    title: 'Dredget Admin Dashboard',
    category: 'web',
    image:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/gnWbTCdueQNDNp57FvRd5R/667_3x_shots_so.png',
    description:
      'Comprehensive admin dashboard for managing job listings, user accounts, and analytics for the Dredget platform.',
    fullDescription:
      'A powerful admin dashboard providing comprehensive tools for managing the Dredget platform. Features include real-time analytics, user management, job listing moderation, and detailed reporting capabilities.',
    technologies: ['React', 'TypeScript', 'Chart.js', 'Material-UI'],
    year: '2023',
    role: 'Dashboard Designer',
  },
  {
    id: 13,
    title: 'Dredget Mobile Map Interface',
    category: 'mobile',
    image:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/eeSWkJ3ccUxeHDGRQefHjv/457shots_so.png',
    description:
      'Location-based job search interface allowing users to find opportunities near them with an intuitive map-based experience.',
    fullDescription:
      'An innovative map-based interface that revolutionizes how users discover job opportunities. The interface provides real-time location tracking, radius-based search, and interactive map markers for seamless job discovery.',
    technologies: ['React Native', 'Mapbox', 'Geolocation API'],
    year: '2023',
    role: 'Mobile UI Designer',
  },
  {
    id: 14,
    title: 'Dredget Messaging System',
    category: 'mobile',
    image:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/rnk8rZ5Tyk8xcGpbNeNaVD/IMG_8552.png',
    description:
      'In-app messaging system enabling direct communication between job seekers and employers for a seamless hiring process.',
    fullDescription:
      'A real-time messaging system designed to facilitate direct communication between job seekers and employers. Features include read receipts, typing indicators, file sharing, and notification management.',
    technologies: ['React Native', 'Socket.io', 'Firebase Cloud Messaging'],
    year: '2023',
    role: 'UX/UI Designer',
  },
  {
    id: 15,
    title: 'Dredget Brand Identity',
    category: 'web',
    image:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/nrvKveWXboUtKioCJSAtxi/15.jpg',
    description:
      'Comprehensive brand identity system for Dredget including logo design, color palette, typography, and visual language.',
    fullDescription:
      'A complete brand identity system that establishes Dredget as a modern, trustworthy job platform. The identity includes logo variations, color systems, typography guidelines, iconography, and brand applications across digital and print media.',
    technologies: ['Adobe Illustrator', 'Figma', 'Brand Guidelines'],
    year: '2023',
    role: 'Brand Designer',
  },
  {
    id: 16,
    title: 'Dredget Billboard Campaign',
    category: 'branding',
    image:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/1cjSt4igEiwSFUFycSRTH6/Scene__11.png',
    description:
      'Outdoor advertising campaign for Dredget featuring striking visuals and compelling messaging to attract new users to the platform.',
    fullDescription:
      'A bold outdoor advertising campaign designed to increase brand awareness and drive app downloads. The campaign features eye-catching visuals, clear messaging, and strategic placement in high-traffic urban areas.',
    technologies: ['Adobe Photoshop', 'Adobe Illustrator', '3D Rendering'],
    year: '2023',
    role: 'Campaign Designer',
  },
  {
    id: 17,
    title: 'KongWear E-commerce App',
    category: 'mobile',
    image:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/1NhPcMdF9EwUXVmM9Fp2cP/154shots_so.png',
    description:
      'Bold fashion e-commerce mobile application featuring the iconic Kong brand identity, product showcases, personalized recommendations, and seamless checkout experience.',
    fullDescription:
      'KongWear is a fashion-forward e-commerce mobile application that brings the power of the Kong brand to life. The app features bold visuals, intuitive product browsing, personalized recommendations, and a streamlined checkout process.',
    technologies: ['React Native', 'Redux', 'Stripe API', 'Firebase'],
    year: '2023',
    role: 'Lead Mobile Designer',
  },
  {
    id: 18,
    title: 'KongWear Brand Identity',
    category: 'branding',
    image:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/9v7DV6jRpbtViyDCV6UMyG/1_copy.gif',
    description:
      'Powerful brand identity for KongWear featuring the gorilla mascot and "Power in Every Thread" tagline, creating a bold and memorable fashion brand presence.',
    fullDescription:
      'A powerful and distinctive brand identity for KongWear that embodies strength, quality, and style. The identity centers around the iconic gorilla mascot and the tagline "Power in Every Thread," creating a memorable brand presence in the fashion industry.',
    technologies: ['Adobe Illustrator', 'After Effects', 'Brand Strategy'],
    year: '2023',
    role: 'Brand Identity Designer',
  },
  {
    id: 19,
    title: 'ORGANIC Green Market',
    category: 'web',
    image:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/bc3RsD5uTVzSUWvEYyvszM/koil.png',
    description:
      'Sustainable marketplace platform connecting local Estonian farms with communities. Features farm discovery, product listings, and location-based search for organic and eco-friendly products.',
    fullDescription:
      'ORGANIC Green Market is a sustainable marketplace platform designed to connect local Estonian farms with environmentally conscious consumers. The platform emphasizes transparency, sustainability, and community building through thoughtful design and user experience.',
    technologies: ['React', 'Node.js', 'PostgreSQL', 'Google Maps API'],
    year: '2023',
    role: 'UX/UI Designer & Developer',
  },
  {
    id: 20,
    title: 'Dredget Mobile UI Redesign',
    category: 'mobile',
    image:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/g61LqwjFgQVf9kfTR32XKX/dbdbdbb.jpg',
    description:
      'Complete UI redesign for the Dredget mobile application with improved usability, visual hierarchy, and engagement metrics.',
    fullDescription:
      'A comprehensive UI redesign that modernizes the Dredget mobile experience. The redesign focuses on improved information hierarchy, enhanced visual appeal, better accessibility, and increased user engagement through thoughtful interaction design.',
    technologies: ['Figma', 'React Native', 'User Testing', 'Analytics'],
    year: '2024',
    role: 'Senior UI Designer',
  },
  {
    id: 21,
    title: 'Architectural Visualization',
    category: 'branding',
    image:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/6c45mKjbBLgQDgW5KThDJ6/680shots_soij.png',
    description:
      'Minimalist architectural visualization project highlighting structural elements with a focus on form, light, and shadow.',
    fullDescription:
      'A minimalist architectural visualization project that explores the relationship between form, light, and shadow. The project emphasizes clean lines, geometric precision, and the interplay of natural and artificial lighting in architectural spaces.',
    technologies: ['Blender', '3ds Max', 'V-Ray', 'Adobe Photoshop'],
    year: '2023',
    role: '3D Artist & Visualizer',
  },
  {
    id: 22,
    title: 'Dredget Marketing Campaign',
    category: 'branding',
    image:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/us77NzGULfuwUpjpLVfRhr/2B2B2B98dddd.png',
    description:
      'Integrated marketing campaign for Dredget featuring cohesive visual identity across digital and print media to increase brand awareness.',
    fullDescription:
      'An integrated marketing campaign designed to increase Dredget brand awareness and drive user acquisition. The campaign features cohesive visual identity across multiple touchpoints including social media, email marketing, print materials, and digital advertising.',
    technologies: ['Adobe Creative Suite', 'Figma', 'Marketing Automation'],
    year: '2023',
    role: 'Creative Director',
  },
]
